import { SurveyType } from '@/features/forms-and-surveys/types'

export const SURVEY_TYPES: SurveyType[] = [
  'CustomerEffortScore',
  'CustomerSatisfactionScore',
  'NetPromoterScore',
  'Onboarding',
  'OpenFeedback',
  'ProductMarketFit',
  'UserInterview',
]
